import { useCallback, useEffect, useState } from 'react';
import { InputProps } from '@treatwell/treatwell-aura';
import { useTranslation } from 'react-i18next';
import { isFormErrorState, useFormContext } from '../../../state';
import { InvalidInputRightComponent } from './get-extra-input-props';

export const useFormErrors = (key: string, withoutSubtext = false) => {
  const { state } = useFormContext();
  const [formErrorsProps, setFormErrorsProps] = useState<Partial<InputProps>>(
    {},
  );
  const { t } = useTranslation('formErrors');

  const clear = useCallback(() => {
    if (isFormErrorState(state)) {
      setFormErrorsProps({});
    }
  }, [state]);

  useEffect(() => {
    if (isFormErrorState(state) && state.map(e => e.key).includes(key)) {
      setFormErrorsProps({
        subText: withoutSubtext ? ' ' : t(key) || '',
        subTextFlavor: 'error',
        innerRightComponent: <InvalidInputRightComponent />,
      });
    }
  }, [state, key, t, withoutSubtext]);

  return { props: formErrorsProps, clear };
};
